export const STAGE = {
    0:'Calling',
    1:'Mis',
    2:'Sales',
    3:'Warehouse',
    4:'Finance',
    5:'Dispatch',
    6:'Complete'
}